import axios from '@/config/axios';
import {
  TARGET_PARAMS,
  ADJOIN_TYPE
} from '@/config/env';

//获取用户档案信息
export const getUserResumeService = (id = "-") => axios(`/centre/graphs/people/search.act?rn=0&ab=.enum,.form,_fork,_text,wx_img&id=${id}`);

//上传图片(单图片上传)
export const sendFileService = (formDate) => axios("/centre/file/create.act", formDate);

//获取用户信息,用户认证和浏览信息
export const getRankAndViewService = () => axios("/common/more.act", {
  "userInfo": {
    "at": "centre/mine/info.jsp?ab=wx_img&rb=*"
  },
  "view": {
    "at": "centre/graphs/mine/acount"
  },
  "vip": {
    "at": "centre/data/vip/auth"
  }
});

//获取创建活动时城市和需求类型
export const getPlaceandTargetService = () => {
  return axios(
    `/centre/graphs/target/select.act?ab=.enum`
  )
};

//获取领域
export const getTradeService = () => axios("/centre/graphs/people/select.act?rb=trade,trade_sub&ab=.enum&type=");

//获取用户权限等级和邀请次数
export const getDigest = () => axios("/centre/data/site/zjww/bill/digest.act");

//获取登录短信验证码
export const getMesCode = (options = {}) => {
  let def = {
    phone: '',
    captcode: ''
  };
  let result = {
    ...def,
    ...options
  };
  return axios(
    `/centre/oauth2/sms/create.act?phone=${result.phone}&captcode=${result.captcode}`,
  )
};


// WEBPACK FOOTER //
// ./src/service/getData.js